import {atom} from 'recoil';

const connectionErrorAtom = atom({
    key: 'connectionError',
    default: false
});

export {connectionErrorAtom};
